import React from 'react'

const ImageCardsBlockComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ImageCardsBlockComponent
